export const CHAT_STORE = 'chat';